(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('configDao', ["$location", "$window", "http", "$q", "futureCache", "$http", "$rootScope", function ($location, $window, http, $q, futureCache, $http, $rootScope) {
        var configDao = {
            param: function (paramName, noCache) {
                var q = http.get('/api/v1/config/' + paramName);
                if (noCache) {
                    q = q.addUuid();
                }
                return q.converter(function (response) {
                    return $q.when(response.data[paramName]);
                });
            },
            setParam: function (paramName, value) {
                return http.post('/api/v1/config/' + paramName).body({ value: value }).run();
            },
            getTrialExpirationDays: function () {
                return configDao.getDeploymentStatus().converter(function (data) {
                    if (data.deployment_mode !== 'poc' && data.deployment_mode !== 'demo') {
                        return $q.when(data);
                    }
                    return $q.when({
                        deployment_mode: data.deployment_mode,
                        pocExpiresInDays: data.pocExpiresInDays,
                        demoExpiresInDays: data.demoExpiresInDays
                    });
                });
            },
            getDeploymentStatus: function () {
                return http.get('/api/v1/deployment_config').addUuid().converter(function (input) {
                    var data = input.data;
                    data.paidExpiresInDays = null;
                    data.paidExpirationDate = null;
                    data.pocExpiresInDays = null;
                    data.pocExpirationDate = null;
                    data.demoExpiresInDays = null;
                    data.demoExpirationDate = null;
                    // check if we should enable google analytics
                    if (data.enable_google_analytics && !$rootScope.googleAnalyticsInitialized) {
                        $rootScope.googleAnalyticsInitialized = true;
                        // Google Analytics Code
                        (function (i, s, o, g, r, a, m) {
                            i.GoogleAnalyticsObject = r;
                            i[r] = i[r] || function () {
                                (i[r].q = i[r].q || []).push(arguments);
                            };
                            i[r].l = 1 * new Date();
                            a = s.createElement(o);
                            m = s.getElementsByTagName(o)[0];
                            a.async = 1;
                            a.src = g;
                            m.parentNode.insertBefore(a, m);
                        }(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga'));
                        $window.ga('create', 'UA-164278719-1', 'auto');
                        // track pageview on state change
                        $rootScope.$on('$routeChangeSuccess', function (event) {
                            $window.ga('send', 'pageview', $location.path());
                        });    /////////////////////////
                    }
                    if (data.deployment_mode == 'paid' && data.paid_duration_in_days) {
                        var paidExpirationDate = null;
                        if (data.paid_start_date) {
                            paidExpirationDate = moment.utc(data.paid_start_date).add(data.paid_duration_in_days, 'days').local();
                        } else if (data.paid_start) {
                            paidExpirationDate = moment.utc(data.paid_start).add(data.paid_duration_in_days, 'days').local();
                        }
                        if (paidExpirationDate) {
                            var paidExpireIn = paidExpirationDate - moment();
                            data.paidExpiresInDays = Math.ceil(paidExpireIn / (1000 * 60 * 60 * 24));
                            if (paidExpireIn < 0 && data.paidExpiresInDays > -1) {
                                data.paidExpiresInDays = -1;
                            }
                            data.paidExpirationDate = paidExpirationDate.format('YYYY-MM-DD HH:mm:ss');
                        }
                    }
                    if (data.deployment_mode == 'poc' && data.poc_duration_in_days) {
                        var associationDate = null;
                        if (data.poc_start_date) {
                            associationDate = moment.utc(data.poc_start_date);
                            if (!associationDate.isValid()) {
                                associationDate = moment.utc(data.poc_start_date, 'YYYY-MM-DD HH:mm:ss');
                            }
                            data.poc_start_date = associationDate.local().format('YYYY-MM-DD HH:mm:ss');
                        } else if (data.association_date) {
                            associationDate = moment.utc(data.association_date);
                            if (!associationDate.isValid()) {
                                associationDate = moment.utc(data.association_date, 'YYYY-MM-DD HH:mm:ss');
                            }
                        }
                        if (associationDate && associationDate.isValid()) {
                            var pocExpirationDate = associationDate.add(data.poc_duration_in_days, 'days').local();
                            var expireIn = pocExpirationDate - moment();
                            data.pocExpiresInDays = Math.ceil(expireIn / (1000 * 60 * 60 * 24));
                            if (expireIn < 0 && data.pocExpiresInDays > -1) {
                                data.pocExpiresInDays = -1;
                            }
                            data.pocExpirationDate = pocExpirationDate.format('YYYY-MM-DD HH:mm:ss');
                        }
                    }
                    if (data.deployment_mode == 'demo' && data.demo_start_date && data.demo_duration_in_days) {
                        var demoExpirationDate = moment.utc(data.demo_start_date).add(data.demo_duration_in_days, 'days').local();
                        var demoExpireIn = demoExpirationDate - moment();
                        data.demoExpiresInDays = Math.ceil(demoExpireIn / (1000 * 60 * 60 * 24));
                        if (demoExpireIn < 0 && data.demoExpiresInDays > -1) {
                            data.demoExpiresInDays = -1;
                        }
                        data.demoExpirationDate = demoExpirationDate.format('YYYY-MM-DD HH:mm:ss');
                    }
                    return $q.when(data);
                }, _.identity);
            },
            getLocalConfJson: function (fileName) {
                return http.get('/api/v1/json/' + fileName).onRequestFail(function () {
                    return $q.when({ data: null });
                }).converter(function (response) {
                    return $q.when(response.data);
                });
            },
            getGlobalConfJson: function (fileName) {
                return http.get('/api/v1/json_files/conf/' + fileName + '.json').onRequestFail(function () {
                    return $q.when({ data: null });
                }).converter(function (response) {
                    return $q.when(response.data);
                });
            },
            getConfJson: function (fileName) {
                return configDao.getLocalConfJson(fileName).preFetch(configDao.getGlobalConfJson(fileName), 'globalConf').converter(function (response, args) {
                    return $q.when(response || args.globalConf);
                }, _.identity);
            },
            apAvananConfig: function () {
                return futureCache.cache('ap-avanan-config', 600000, function () {
                    return http.get('/api/v1/json_files/modules/ap_avanan/conf/ui_categories.json').converter(function (response) {
                        return $q.when(response.data);
                    });
                });
            },
            getSamlConfig: function () {
                return http.get('/api/v1/saml_config');
            },
            saveSamlConfig: function (data) {
                var fd = new FormData();
                _(data).each(function (val, key) {
                    fd.set(key, val);
                });
                return $http.post('/api/v1/saml_config', fd, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                });
            },
            getPortalUrlConfig: function () {
                return http.get('/api/v1/portal_url_config');
            },
            licensesManager: function () {
                return http.post('/api/v1/licenses_manager');
            }
        };
        return configDao;
    }]);
}());